module.exports = __webpack_public_path__ + "img/logo-carvalho.5754923d.png";